import { COUNTRY_CODES, countryMap } from "../constants/countries";

/**
 * Cómo se llama el impuesto en el papel de cada país.
 *
 * El tiquete genérico —el de Ecuador, Paraguay y Puerto Rico— rotulaba «IVA» en
 * los tres. En Puerto Rico el impuesto es el **IVU** (Impuesto sobre Ventas y
 * Uso), y un recibo que nombra un impuesto que allá no existe es un recibo mal
 * hecho. Sólo se declaran los que difieren: el resto sigue con «IVA».
 */
const IMPUESTO_EN_PAPEL = {
  [COUNTRY_CODES.PUERTORICO]: "IVU",
};

export const nombreDelImpuesto = (pais) => IMPUESTO_EN_PAPEL[pais] ?? "IVA";

/**
 * El nombre del país, en mayúsculas, para la cabecera del papel.
 *
 * Los dos tiquetes sólo traducían Ecuador y escribían el código crudo de
 * cualquier otro: «PR» en vez de «PUERTO RICO». Un código que no es de un país
 * del terminal —la tienda puede tener cualquiera de la lista de clientes— se
 * sigue escribiendo tal como viene.
 */
export const nombreDelPaisEnPapel = (codigo) =>
  countryMap[codigo]?.name?.toUpperCase() ?? codigo;
